<template>
  <el-select  filterable allow-create
   v-model="model[schema.model.split('.')[0]][schema.model.split('.')[1]]"
   :multiple="schema.multiple"
   @change="$emit('model-updated', $event, schema.model)"
   @remove-tag="removeData(tag)"
   :default-first-option="true"
   >
    <el-option
      v-for="(item, index) in schema.value"
      :key="index"
      :label="item.libelle"
      :value="item.value"
    ></el-option>
  </el-select>
</template>

<script>
import { abstractField } from "vue-form-generator";
import { RemoveFieldBus } from "../removefield-bus";
import firebase from "firebase";
import {
  get as objGet,
  forEach,
  isFunction,
  isString,
  isArray,
  debounce,
  uniqueId,
  uniq as arrayUniq
} from "lodash/core";

export default {
  mixins: [abstractField],

  data() {
    return {
      produitRef: firebase.firestore().collection("financier"),
      projectId: JSON.parse(localStorage.getItem("userSession")).projet
    };
  },
  computed: {
    value: {
      cache: false,
      get() {
        let val;
        if (isFunction(objGet(this.schema, "get"))) {
          val = this.schema.get(this.model);
        } else {
          val = objGet(this.model, this.schema.model);
        }

        return this.formatValueToField(val);
      },

      set(newValue) {
        let oldValue = this.value;
        newValue = this.formatValueToModel(newValue);

        if (isFunction(newValue)) {
          newValue(newValue, oldValue);
        } else {
          this.updateModelValue(newValue, oldValue);
        }
      }
    }
  },

  mounted(){
    if(this.$route.params.dataToUpdate){
      this.model.recettes.type=this.$route.params.dataToUpdate.type;
      // this.model.recettes.recette=this.$route.params.dataToUpdate.recette;
      this.model.client.nom=this.$route.params.dataToUpdate.client.nom
      // this.model.client.prenom=this.$route.params.dataToUpdate.client.prenom
      // this.model.client.telephone1=this.$route.params.dataToUpdate.client.telephone1
      this.model.recettes.libelle=this.$route.params.dataToUpdate.libelle
      this.model.client.vendeur.nom=this.$route.params.dataToUpdate.vendeur.nom
    }
  },

 
  
  methods: {
    // updateFieldRecette(){
  
    // },
    removeData(model){
      let oldValue = this.value;
      RemoveFieldBus.$emit("remove-tag", oldValue, model);
    },
    changeData(){
    
    this.$emit('model-updated', this.model.recettes.libelle, this.schema.model)
    },
    isEmpty(obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    },
    updateModelValue(newValue, oldValue) {
      let changed = false;
      if (isFunction(this.schema.set)) {
        this.schema.set(this.model, newValue);
        changed = true;
      } else if (this.schema.model) {
        this.setModelValueByPath(this.schema.model, newValue);
        changed = true;
      }

      if (changed) {
        if (newValue.length < oldValue.length) {
          RemoveFieldBus.$emit("remove-tag", oldValue, newValue);
        } else
        if(newValue.length==0) {
          this.$emit("model-updated", newValue, this.schema.model);
        }
        else{
          // this.$emit("model-updated", newValue, this.schema.model);
        }

        if (isFunction(this.schema.onChanged)) {
          this.schema.onChanged.call(
            this,
            this.model,
            newValue,
            oldValue,
            this.schema
          );
          console.log("Call");
        }

        if (objGet(this.formOptions, "validateAfterChanged", false) === true) {
          if (
            objGet(
              this.schema,
              "validateDebounceTime",
              objGet(this.formOptions, "validateDebounceTime", 0)
            ) > 0
          ) {
            this.debouncedValidate();
          } else {
            this.validate();
          }
        }
      }
    }
  }
};
</script>
